import { useTheme } from "@/context/ThemeContext";
import DualPaneView from "../components/DualPaneView";
import { cardDataMap } from "../data";
import ExperienceShell from "../ExperienceShell";

export default function ZodiacExperiencePage() {
  const { effectiveTheme } = useTheme();

  return (
    <ExperienceShell activeId="zodiac" contentKey="zodiac">
      <DualPaneView data={cardDataMap.zodiac} isLight={effectiveTheme === "light"} />
    </ExperienceShell>
  );
}
